import { render, staticRenderFns } from "./GroupGeo.vue?vue&type=template&id=632bb4da&scoped=true&"
import script from "./GroupGeo.vue?vue&type=script&lang=js&"
export * from "./GroupGeo.vue?vue&type=script&lang=js&"
import style0 from "./GroupGeo.vue?vue&type=style&index=0&id=632bb4da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632bb4da",
  null
  
)

export default component.exports